import { safeString, conditionalValue } from "../../helpers";
import { parseSettlementStatus, getIsCashOutOrCancelled } from "../parseSettlementStatus";
import { isBoostPlayerBonus, isGuaranteedPayoutBonus } from "../../helpers";
export const getBonusOdds = (bet, playerBonus) => {
    const settlementStatus = parseSettlementStatus(bet.settlementStatus);
    const isCashOutOrCancelled = getIsCashOutOrCancelled(settlementStatus);
    if (isBoostPlayerBonus(playerBonus)) {
        const variant = isGuaranteedPayoutBonus(playerBonus) ? "guaranteedOdds" : "boostedOdds";
        const odds = !isCashOutOrCancelled && playerBonus.status === "Inactive" && isGuaranteedPayoutBonus(playerBonus) ?
            {
                originalDisplayOdds: safeString(bet.originalDisplayOdds),
                newOdds: safeString(bet.displayOdds),
                newOddsVariant: conditionalValue(!!bet.displayOdds, "betTitle", undefined)
            } : {
            originalDisplayOdds: safeString(bet.displayOdds),
            newOdds: playerBonus.boostDisplayOdds,
            newOddsVariant: conditionalValue(bet.earlyExitStatus === "Applied", "betTitle", variant)
        };
        return odds;
    }
    const newOdds = conditionalValue(bet.earlyExitStatus === "Applied", safeString(bet.displayOdds), undefined);
    return {
        originalDisplayOdds: conditionalValue(bet.earlyExitStatus === "Applied", safeString(bet.originalDisplayOdds), safeString(bet.displayOdds)),
        newOdds,
        newOddsVariant: conditionalValue(!!newOdds, "betTitle", undefined)
    };
};
//# sourceMappingURL=getBonusOdds.js.map